<div class="context-menu" [@slide]="getAnimationState()" [ngClass]="containerClasses">
  <ul>
    <li *ngFor="let item of items" (click)="onItemClick(item)" [ngClass]="{'selected-item': item === selectedItem}">
      <div class="label-container">
        <img *ngIf="itemHasIcon(item)" [src]="item.imageUrl">
        <div class="label-badge-container">
          <p class="menu-item-label">
            {{ item.label }}
          </p>
          <core-badge *ngIf="item.badge" class="menu-item-badge" [color]="item.badge.color" [label]="item.badge.label"></core-badge>
        </div>
      </div>
      <div class="menu-item-description" [ngClass]="{ 'menu-item-with-icon': itemHasIcon(item) }">{{ item.description }}
      </div>
    </li>
  </ul>
</div>
